import React from "react";
import { Icon } from "@clarkinc/zest-design-system";
import FooterCategoryData from "./FooterCategoryData";
import spritePath from "~/common/Icons/Zest/remixicon.symbol.v1.svg";

const MobileFooterCategoryContainer = () => {
  return (
    <div className="flex flex-col md:hidden pb-5">
      {FooterCategoryData.map((category) => (
        <details
          key={category.categoryHeader}
          className="first:mt-0 mt-3 border border-solid rounded border-green-300 w-full group"
        >
          <summary className="!flex text-white text-lg font-bold px-3 py-2 marker:content-none border-0 [&::-webkit-details-marker]:hidden group-open:border-b group-open:border-solid group-open:border-green-300">
            <span className="!flex items-center justify-between w-full">
              {category.categoryHeader}
              <Icon
                className="fill-white group-open:rotate-180 group-open:transition-all group-open:ease-in group-open:duration-100"
                size="small"
                name="ri-arrow-down-s-line"
                spriteSheetHref={spritePath}
              />
            </span>
          </summary>
          <ul className="m-0 list-none pl-3 p-0">
            {category.categoryList.map((list) => (
              <li key={list.name} className="first:pt-2-1/2 last:pb-2-1/2">
                <a
                  className="text-sm text-white leading-[30px] hover:underline no-underline"
                  {...(list.name.toLowerCase() === "safety recall" && {
                    target: "_blank",
                    rel: "noopener",
                  })}
                  href={list.link}
                >
                  {list.name}
                </a>
              </li>
            ))}
          </ul>
        </details>
      ))}
    </div>
  );
};

export default MobileFooterCategoryContainer;
